import { EventEmitter } from '@angular/core';
import { ErrorStateMatcher } from '@angular/material/core';
import { FieldValue } from '@change-requests/types/field.value.type';

export abstract class InputComponent<T extends FieldValue | null = string> {
    disabled = true;
    ariaLabel = '';
    errorMessage?: string = undefined;
    errorStateMatcher: ErrorStateMatcher = {
        isErrorState: () => Boolean(this.errorMessage),
    };

    abstract valueUpdated: EventEmitter<T>;
    abstract value: T;
}
